/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.06.17.
 */

import alt from './alt';
import BaseRestActions from "./BaseRestActions";
import BaseRestStore from "./BaseRestStore";


let dynamicActions = {};
let dynamicStores = {};

/**
 * Returns AltJS Actions object based by object name. If this object does not exist then it will be created automatically
 * from BaseRestActions class.
 * @param {string} resourceName REST API resource name used for store corresponding for this actions object
 * @param {string} storeName Store name. If missing then resource name will be used
 * @returns {BaseRestActions}
 */
export function getActions(resourceName, storeName=undefined) {
    if (storeName == null) storeName = resourceName;
    // Ensure store is loaded!
    getStore(resourceName, storeName);
    return getActionsInternal(storeName);
}

function getActionsInternal(storeName) {
    if (dynamicActions[storeName]) return dynamicActions[storeName];
    let actionsObject = alt.createActions(BaseRestActions);
    dynamicActions[storeName] = actionsObject;
    return actionsObject;
}

/**
 * Returns AltJS Store object based by object name. If this stoer does not exist then it will be created automatically
 * from BaseRestStore class
 * @param {string} resourceName REST API resource name used for this store
 * @param {string} storeName Store name. If missing then resource name will be used
 * @returns {BaseRestStore}
 */
export function getStore(resourceName, storeName=undefined) {
    if (storeName == null) storeName = resourceName;
    if (dynamicStores[storeName]) return dynamicStores[storeName];
    let storeObject = alt.createStore(BaseRestStore, storeName, getActionsInternal(storeName), resourceName);
    dynamicStores[storeName] = storeObject;
    return storeObject;
}

export function removeStore(storeName) {
    if (dynamicStores[storeName]) {
        if (alt.getStore(storeName)) delete alt.stores[storeName];
        delete dynamicStores[storeName];
    }
    if (dynamicActions[storeName]) {
        if (alt.getActions(storeName)) delete alt.actions[storeName];
        delete dynamicActions[storeName];
    }
}
